import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TuiPortals, TuiPortalService, tuiProvide, TuiVCR } from '@taiga-ui/cdk';
import { DrawerPortalService } from './drawer-portal.service';

@Component({
  selector: 'pxc-drawer-portal',
  imports: [TuiVCR],
  templateUrl: './drawer-portal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'fixed flex flex-col items-center top-0 h-full w-full pointer-events-none z-10' },
  providers: [tuiProvide(TuiPortalService, DrawerPortalService)],
})
export class DrawerPortalComponent extends TuiPortals {}
